import React, { useCallback } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { isOutOfCoreHours } from '@gumtree/shared/src/util/core-hours';
import { loginThenComeBack as loginThenComeBackThunk } from '@gumtree/shell/src/common/common-actions';
import { VipState, VipUseDispatch } from '../../reducers';
import revealPhoneUtil from './reveal-phone-util';
import SellerPhone from '../seller-phone/app';
import { updateShowOutOfHoursMessage } from '../../reducers/post-call';

const SellerPhoneRevealLogic = ({ skipLoginToReveal, isMotorsCTATask3 }: Props) => {
    const dispatch = useDispatch() as VipUseDispatch;
    const loginThenComeBack = useCallback(() => dispatch(loginThenComeBackThunk()), []);
    const revealPhone = (e: React.MouseEvent) => {
        revealPhoneUtil(e, dispatch, sellerContactDetails, adDetails, baseConfig, '', skipLoginToReveal, (type: 'reveal' | 'redirectToApp') => {
            if (type !== 'reveal' || !isMotorsCTATask3) return;
            if (isOutOfCoreHours()) {
                dispatch(updateShowOutOfHoursMessage(true));
            }
        });
    }
    
    const {
        adDetails,
        baseConfig,
        sellerContactDetails,
        sellerContactDetails: {
            replyPhone,
            revealedNumber,
            userLoggedIn,
            showRevealNumber,
            isLoginRequiredToContactForVipCategory,
            revealNumberUnmasked,
            revealPhoneCallbackUrl,
        },
        adDetails: { pro, containsCallTrackingFeature },
        requestId
    } = useSelector(
        ({ adDetails, baseConfig, sellerContactDetails, requestId }: VipState) => ({
            adDetails,
            baseConfig,
            sellerContactDetails,
            isMotors: adDetails.l1CategorySeoName === 'cars-vans-motorbikes',
            isFromMotorsFeed: adDetails.isFromMotorsFeed,
            requestId
        }),
        shallowEqual
    );

    const handleRevealPhone = (e) => {
        e.preventDefault();
        revealPhone(e);
    };

    return (
        <SellerPhone
            replyPhone={replyPhone}
            revealPhone={handleRevealPhone}
            revealedNumber={revealedNumber}
            showRevealNumber={showRevealNumber}
            revealPhoneCallbackUrl={revealPhoneCallbackUrl}
            revealNumberUnmasked={revealNumberUnmasked}
            isLoginRequiredToContactForVipCategory={isLoginRequiredToContactForVipCategory}
            isUserLoggedIn={userLoggedIn}
            pro={pro}
            l1CategorySeoName={adDetails.l1CategorySeoName}
            containsCallTrackingFeature={containsCallTrackingFeature}
            isStickyHeader={false}
            loginThenComeBack={loginThenComeBack}
            adId={adDetails.id.toString()}
            requestId={requestId}
            skipLoginToReveal={skipLoginToReveal}
        />
    );  
};


interface Props {
    skipLoginToReveal?: boolean;
    isMotorsCTATask3?: boolean;
}

export default SellerPhoneRevealLogic;
